import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListCompanyWarehouseAccessesActions as Actions,
  ListCompanyWarehouseAccessesRequestAction as RequestAction,
} from 'store/ducks/companyWarehouseAccesses';

export function* listCompanyWarehouseAccessesRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('company-warehouse-accesses', {
      ...query,
      asList: 1,
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
